import { useEffect, useState } from "react";
import axiosInstance from "../helpers/axiosInstance";
import { useParams, useNavigate } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import Edit from '../images/edit.png';
import { FaFilter } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { FaTrash } from "react-icons/fa";

const ViewTrip = () => {
    const { id } = useParams();
    const [trip, setTrip] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [shopOptions, setShopOptions] = useState([]);
    const [bays, setBaysData] = useState([]);
    const [routesToShow, setRoutesToShow] = useState(2);
    const [showMore, setShowMore] = useState(false);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [shops, setShops] = useState([]);
    const [unloadingLocations, setUnloadingLocations] = useState([]);
    const [locationOptions, setLocationOptions] = useState(false);
    const [timeError, setTimeError] = useState("");

    const [addModalOpen, setAddModalOpen] = useState(false);
    const [selectedAddRoute, setSelectedAddRoute] = useState(null);
    const [AddFormData, setAddFormData] = useState({
        shop_id: "",
        unloading_location_id: "",
        bay_id: "",
        bay_time_from: "",
        bay_time_to: "",
    });


    const [formData, setFormData] = useState({
        shop_id: "",
        unloading_location_id: "",
        bay_id: "",
        bay_time_from: "",
        bay_time_to: "",
    });


    const navigate = useNavigate();

    useEffect(() => {
        fetchTripDetails();

        axiosInstance.get("/api/shop/shops")
            .then((response) => {
                setShops(response.data.shops);
                const uniqueShopNames = response.data.shops.map(item => item.shop_name).filter(Boolean);
                setShopOptions(uniqueShopNames);
            })

            .catch(error => console.error("Error fetching shops:", error));


        axiosInstance.get("/api/unloading-location")
            .then((response) => {
                setUnloadingLocations(response.data.locations)
                const uniqueLocationNames = response.data.locations.map(item => item.location_name).filter(Boolean);
                setLocationOptions(uniqueLocationNames);
            })
            .catch(error => console.error("Error fetching unloading locations:", error));






    }, [id]);

    const fetchTripDetails = async () => {
        try {
            const response = await axiosInstance.get(`/api/trip/trip/${id}`);
            setTrip(response.data.data);
        } catch (err) {
            setError("Failed to fetch trip details.");
            console.error("Error:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleToggleView = () => {
        setShowMore(!showMore);
        setRoutesToShow(showMore ? 2 : trip?.TripRoutes?.length || 0);
    };

    const handleUpdateTripRoute = async (stop_order) => {

        console.log(selectedRoute)

        try {
            const response = await axiosInstance.put(`/api/trip/${selectedRoute.id}`, {
                trip_id: id,
                shop_id: formData.shop_id,
                unloading_location_id: formData.unloading_location_id,
                bay_number_id: formData.bay_id,
                bay_time_from: formData.bay_time_from,
                bay_time_to: formData.bay_time_to,
                stop_order: stop_order
            });



            if (response.data.success) {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: response.message || "Trip route updated successfully",
                });

                setEditModalOpen(false)
                fetchTripDetails();
            }
        } catch (error) {
            console.error("Error updating trip route:", error);

            const backendMessage =
                error.response?.data?.message ||
                error.response?.data?.error ||
                "Failed to update trip route.";

            alert(backendMessage);
        }

    };

    const handleDeleteTripRoute = (route) => {
        // Build the HTML content for SweetAlert
        const routeDetails = `
            <div style="text-align: center;">
                <p></p>
                <p><strong>Shop:</strong> ${route.Shop?.shop_name || "-"}</p>
                <p><strong>Unloading Location:</strong> ${route.UnloadingLocation?.location_name || "-"}</p>
                <p><strong>Bay:</strong> ${route.Bay?.number || "-"}</p>
                <p><strong>Time:</strong> ${route.bay_time_from && route.bay_time_to
                ? `${formatTime(route.bay_time_from)} - ${formatTime(route.bay_time_to)}`
                : "-"
            }</p>
            </div>
        `;

        Swal.fire({
            title: 'Are you sure?',
            html: `<strong>You are about to delete this trip route:</strong>${routeDetails}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axiosInstance.put(`/api/trip/tripRoute/delete/${route.id}`);
                    if (response.data.success) {
                        Swal.fire('Deleted!', 'Trip route has been marked as deleted.', 'success');
                        fetchTripDetails(); // refresh the trip routes
                    } else {
                        Swal.fire('Error!', response.data.message || 'Failed to delete.', 'error');
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire('Error!', 'Something went wrong.', 'error');
                }
            }
        });
    };

    const handleAddTripRoute = async () => {
        console.log("this function is called");
        try {
            const response = await axiosInstance.post(`/api/trip/addTripRoute`, {
                trip_id: id,
                shop_id: AddFormData.shop_id,
                unloading_location_id: AddFormData.unloading_location_id,
                bay_number_id: AddFormData.bay_id,
                bay_time_from: AddFormData.bay_time_from,
                bay_time_to: AddFormData.bay_time_to,
            });

            // Check for success
            if (response.status === 200) {
                setAddModalOpen(false);
                Swal.fire({
                    icon: "success",
                    title: "Route Added!",
                    text: "New trip route has been added successfully.",
                    confirmButtonColor: "#0a4595",
                });
                fetchTripDetails();

                // Optionally close modal and reset form

                setAddFormData({
                    shop_id: "",
                    unloading_location_id: "",
                    bay_id: "",
                    bay_time_from: "",
                    bay_time_to: "",
                });

                // Refresh trip routes if needed
                // fetchTripRoutes(); // call your fetch function if exists
            } else {
                setAddModalOpen(false);
                Swal.fire({
                    icon: "error",
                    title: "Oops!",
                    text: "Something went wrong while adding the route.",
                    confirmButtonColor: "#0a4595",
                });
            }
        } catch (error) {
            console.error(error);
            setAddModalOpen(false);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.response?.data?.message || "Failed to add route",
                confirmButtonColor: "#0a4595",
            });
        }
    };




    useEffect(() => {
        if (formData.shop_id && formData.unloading_location_id) {
            callBays(formData);
        }
    }, [formData.shop_id, formData.unloading_location_id]);

    useEffect(() => {
        console.log(AddFormData)

        if (AddFormData.shop_id && AddFormData.unloading_location_id) {
            callBays(AddFormData);
        }
    }, [AddFormData.shop_id, AddFormData.unloading_location_id]);

    const callBays = (formData) => {
        axiosInstance
            .get(`/api/bays/getBays?shop_id=${formData.shop_id}&location_id=${formData.unloading_location_id}`)
            .then((response) => {
                console.log(response.data)
                setBaysData(response.data.data); // assuming the response returns `bays`
            })
            .catch((error) => console.error("Error fetching bays:", error));
    };


    if (loading) return <p>Loading trip details...</p>;
    if (error) return <p className="text-danger">{error}</p>;
    if (!trip) return <p>No trip found.</p>;

    const formatTime = (timeStr) => {
        if (!timeStr) return "-";
        const [hourStr, minuteStr] = timeStr.split(":");
        let hour = parseInt(hourStr, 10);
        const minute = minuteStr || "00";
        const ampm = hour >= 12 ? "PM" : "AM";
        hour = hour % 12 || 12;
        return `${hour}:${minute} ${ampm}`;
    };

    const validateTime = (from, to) => {
        if (!from || !to) {
            setTimeError("Please select both 'Bay Time From' and 'Bay Time To'.");
            return false;
        }

        // Convert to comparable minutes
        const [fromH, fromM] = from.split(":").map(Number);
        const [toH, toM] = to.split(":").map(Number);
        const fromTotal = fromH * 60 + fromM;
        const toTotal = toH * 60 + toM;

        if (fromTotal >= toTotal) {
            setTimeError("'Bay Time To' must be greater than 'Bay Time From'.");
            return false;
        }
        setTimeError("");
        return true;
    };

    var activeRoutes = trip.TripRoutes

    // .filter(route => !route.is_deleted);


    return (
        <div className="trip-details-container m-4">
            <div className="device-details-card p-4 rounded">
                <div className="device-header mb-4">

                    <div className="device-info position-relative">
                        <div className="info-grid d-flex flex-wrap gap-4 align-items-center">
                            <div className="info-item me-2">
                                <span className="info-label fw-semibold text-muted">Vendor Code</span>
                                <h1 className="device-name">
                                    <i className="bi bi-truck"></i>{trip.vendor_code}
                                </h1>
                            </div>

                            <div className="info-item me-2">
                                <span className="info-label fw-semibold text-muted">Bay Type</span>
                                <div className="device-type fs-6">
                                    <i className="bi bi-tags"></i>
                                    {trip.BayType?.type_name || "N/A"}
                                </div>
                            </div>

                            <div className="info-item">
                                <span className="info-label fw-semibold text-muted">Truck Length</span>
                                <div className="device-type fs-6">
                                    {trip.truck_length}
                                </div>
                            </div>
                        </div>

                        <div className="position-absolute end-0 top-0 text-end">
                            <span className={`status-badge ${trip?.is_deleted ? "inactive" : "active"}`}>
                                {trip?.is_deleted ? "INACTIVE" : "ACTIVE"}
                            </span>
                            <div className="fw-bold text-dark fs-5 mt-3">{trip.route_name}</div>
                        </div>
                    </div>
                </div>

                <div className="d-flex align-items-center justify-content-between mb-3">
                    <h2 className="bay-title" style={{ fontWeight: 600, color: "#333" }}>
                        <i className="bi bi-info-circle me-2 text-primary"></i>
                        Trip Routes Overview
                    </h2>
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={() => {
                            setAddFormData({
                                shop_id: "",
                                unloading_location_id: "",
                                bay_id: "",
                                bay_time_from: "",
                                bay_time_to: "",
                            });
                            setSelectedAddRoute(null); // no selected route for add
                            setAddModalOpen(true);
                        }}
                    >
                        + Add Route
                    </button>
                </div>

                {trip.TripRoutes && trip.TripRoutes.length > 0 ? (
                    <>
                        <div
                            className="trip-route-overview"
                            style={{
                                maxHeight: showMore ? "400px" : "auto",
                                overflowY: showMore ? "auto" : "visible",
                                overflowX: "hidden",
                            }}
                        >
                            {activeRoutes.slice(0, routesToShow).map((route, index) => (
                                <div
                                    key={route.id || index}
                                    className="d-flex flex-row justify-content-between align-items-center py-3"
                                    style={{ borderBottom: index !== routesToShow - 1 ? "1px solid #ccc" : "none" }}
                                >
                                    <div className="flex-fill px-2">
                                        <div className="text-muted small">Shop Name</div>
                                        <div className="fw-semibold">{route.Shop?.shop_name || "-"}</div>
                                    </div>
                                    <div className="flex-fill px-2 text-center">
                                        <div className="text-muted small">Unloading Location</div>
                                        <div className="fw-semibold">{route.UnloadingLocation?.location_name || "-"}</div>
                                    </div>
                                    <div className="flex-fill px-2 text-center">
                                        <div className="text-muted small">Bay Number</div>
                                        <div className="fw-semibold">{route.Bay?.number || "-"}</div>
                                    </div>
                                    <div className="flex-fill px-2 text-end">
                                        <div className="text-muted small">Time</div>
                                        <div className="fw-semibold">
                                            {route.bay_time_from && route.bay_time_to
                                                ? `${formatTime(route.bay_time_from)} - ${formatTime(route.bay_time_to)}`
                                                : "-"}
                                        </div>
                                    </div>

                                    <div className="flex-fill px-2 text-end">
                                        <img
                                            src={Edit}
                                            alt="Edit"
                                            className="action-icon mx-2"
                                            style={{ width: "18px", height: "18px", cursor: "pointer" }}
                                            title="Edit"
                                            onClick={() => {
                                                setSelectedRoute(route);
                                                setFormData({
                                                    shop_id: route.shop_id || "",
                                                    unloading_location_id: route.unloading_location_id || "",
                                                    bay_id: route.bay_number_id || "",
                                                    bay_time_from: route.bay_time_from || "",
                                                    bay_time_to: route.bay_time_to || "",
                                                });
                                                setEditModalOpen(true);
                                            }}
                                        />

                                        {/* {activeRoutes.length > 1 && (
                                            <FaTrash
                                                style={{ cursor: "pointer", color: "red", marginLeft: "10px" }}
                                                title="Delete"
                                                onClick={() => handleDeleteTripRoute(route)}
                                            />
                                        )} */}

                                    </div>




                                    {editModalOpen && (
                                        <div
                                            onClick={() => setEditModalOpen(false)}
                                            style={{
                                                position: "fixed",
                                                inset: 0,
                                                background: "rgba(0, 0, 0, 0.1)",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                zIndex: 9999,
                                                padding: "20px",
                                            }}
                                        >
                                            <div
                                                onClick={(e) => e.stopPropagation()}
                                                style={{
                                                    background: "#fff",
                                                    borderRadius: "16px",
                                                    width: "100%",
                                                    maxWidth: "600px",
                                                    padding: "24px",
                                                    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.0)",
                                                    overflowY: "auto",
                                                    maxHeight: "90vh",
                                                    fontFamily: "'Inter', sans-serif",
                                                }}
                                            >
                                                {/* Header */}
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        borderBottom: "1px solid #eee",
                                                        paddingBottom: "16px",
                                                        marginBottom: "24px",
                                                    }}
                                                >
                                                    <h2 style={{ margin: 0, fontSize: "22px", fontWeight: 600, color: "#333" }}>
                                                        Edit Route
                                                    </h2>
                                                    <button
                                                        onClick={() => setEditModalOpen(false)}
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            fontSize: "22px",
                                                            fontWeight: "bold",
                                                            cursor: "pointer",
                                                            color: "#999",
                                                        }}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>

                                                {/* Form Inputs in One Row */}
                                                <form
                                                    onSubmit={(e) => {
                                                        e.preventDefault();
                                                        if (validateTime(formData.bay_time_from, formData.bay_time_to)) {
                                                            handleUpdateTripRoute(route.stop_order);
                                                        }
                                                        handleUpdateTripRoute(route.id);
                                                    }}
                                                    style={{
                                                        display: "flex",
                                                        gap: "20px",
                                                        flexWrap: "wrap",
                                                        marginBottom: "20px",
                                                    }}
                                                >
                                                    {/* Shop */}
                                                    <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                                                        <div style={{ flex: 1, minWidth: "170px" }}>
                                                            <label>Shop</label>
                                                            <select
                                                                className="form-control"
                                                                value={formData.shop_id}
                                                                onChange={(e) =>
                                                                    setFormData({ ...formData, shop_id: Number(e.target.value) })
                                                                }
                                                            >
                                                                <option value="">Select Shop</option>
                                                                {shops?.map((shop) => (
                                                                    <option key={shop.id} value={shop.id}>
                                                                        {shop.shop_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Unloading Location */}
                                                        <div style={{ flex: 1, minWidth: "170px" }}>
                                                            <label>Unloading Location</label>
                                                            <select
                                                                className="form-control"
                                                                value={formData.unloading_location_id}
                                                                onChange={(e) =>
                                                                    setFormData({ ...formData, unloading_location_id: Number(e.target.value) })

                                                                }
                                                            >
                                                                <option value="">Select Location</option>
                                                                {unloadingLocations?.map((loc) => (
                                                                    <option key={loc.id} value={loc.id}>
                                                                        {loc.location_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Bay */}
                                                        <div style={{ flex: 1, minWidth: "170px" }}>
                                                            <label>Bay</label>
                                                            <select
                                                                className="form-control"
                                                                value={formData.bay_id}
                                                                onChange={(e) => setFormData({ ...formData, bay_id: Number(e.target.value) })}
                                                            >
                                                                <option value="">Select Bay</option>
                                                                {bays?.map((bay) => (
                                                                    <option key={bay.id} value={bay.bay_id}>
                                                                        {bay.number}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* Bay Time From */}
                                                    <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                                                        <div style={{ flex: 1, minWidth: "170px" }}>
                                                            <label>Bay Time From</label>
                                                            <input
                                                                type="time"
                                                                className="form-control"
                                                                value={formData.bay_time_from}
                                                                onChange={(e) => {
                                                                    setFormData({ ...formData, bay_time_from: e.target.value });
                                                                    setTimeError(""); // clear error on change
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Bay Time To */}
                                                        <div style={{ flex: 1, minWidth: "170px" }}>
                                                            <label>Bay Time To</label>
                                                            <input
                                                                type="time"
                                                                className="form-control"
                                                                value={formData.bay_time_to}
                                                                onChange={(e) => {
                                                                    setFormData({ ...formData, bay_time_to: e.target.value });
                                                                    setTimeError(""); // clear error on change
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {timeError && (
                                                        <div
                                                            style={{
                                                                color: "red",
                                                                fontSize: "13px",
                                                                marginTop: "-10px",
                                                                marginBottom: "10px",
                                                                textAlign: "left",
                                                            }}
                                                        >
                                                            {timeError}
                                                        </div>
                                                    )}

                                                </form>


                                                {/* Buttons */}
                                                <div style={{ textAlign: "right" }}>
                                                    <button
                                                        type="button"
                                                        onClick={() => setEditModalOpen(false)}
                                                        style={{
                                                            padding: "10px 16px",
                                                            marginRight: "10px",
                                                            backgroundColor: "#e0e0e0",
                                                            color: "#333",
                                                            border: "none",
                                                            borderRadius: "6px",
                                                            fontSize: "13px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            if (validateTime(formData.bay_time_from, formData.bay_time_to)) {
                                                                handleUpdateTripRoute(route.stop_order);
                                                            }
                                                        }}

                                                        style={{
                                                            padding: "10px 20px",
                                                            backgroundColor: 'rgb(10, 69, 149)',
                                                            color: "#fff",
                                                            border: "none",
                                                            borderRadius: "6px",
                                                            fontSize: "13px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        Update
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {addModalOpen && (
                                        <div
                                            onClick={() => setAddModalOpen(false)}
                                            style={{
                                                position: "fixed",
                                                inset: 0,
                                                background: "rgba(0, 0, 0, 0.1)",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                zIndex: 9999,
                                                padding: "20px",
                                            }}
                                        >
                                            <div
                                                onClick={(e) => e.stopPropagation()}
                                                style={{
                                                    background: "#fff",
                                                    borderRadius: "16px",
                                                    width: "100%",
                                                    maxWidth: "600px",
                                                    padding: "24px",
                                                    overflowY: "auto",
                                                    maxHeight: "90vh",
                                                    fontFamily: "'Inter', sans-serif",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        borderBottom: "1px solid #eee",
                                                        paddingBottom: "16px",
                                                        marginBottom: "24px",
                                                    }}
                                                >
                                                    <h2 style={{ margin: 0, fontSize: "22px", fontWeight: 600, color: "#333" }}>
                                                        Add New Route
                                                    </h2>
                                                    <button
                                                        onClick={() => setAddModalOpen(false)}
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            fontSize: "22px",
                                                            fontWeight: "bold",
                                                            cursor: "pointer",
                                                            color: "#999",
                                                        }}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>

                                                {/* Form Inputs */}
                                                <form
                                                    onSubmit={(e) => {
                                                        e.preventDefault();
                                                        if (validateTime(AddFormData.bay_time_from, AddFormData.bay_time_to)) {
                                                            handleAddTripRoute();
                                                        }
                                                    }}
                                                    style={{ display: "flex", gap: "20px", flexWrap: "wrap", marginBottom: "20px" }}
                                                >
                                                    {/* Shop */}
                                                    <div style={{ flex: 1, minWidth: "170px" }}>
                                                        <label>Shop</label>
                                                        <select
                                                            className="form-control"
                                                            value={AddFormData.shop_id}
                                                            onChange={(e) => setAddFormData({ ...AddFormData, shop_id: Number(e.target.value) })}
                                                        >
                                                            <option value="">Select Shop</option>
                                                            {shops?.map((shop) => (
                                                                <option key={shop.id} value={shop.id}>
                                                                    {shop.shop_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    {/* Unloading Location */}
                                                    <div style={{ flex: 1, minWidth: "170px" }}>
                                                        <label>Unloading Location</label>
                                                        <select
                                                            className="form-control"
                                                            value={AddFormData.unloading_location_id}
                                                            onChange={(e) =>
                                                                setAddFormData({ ...AddFormData, unloading_location_id: Number(e.target.value) })
                                                            }
                                                        >
                                                            <option value="">Select Location</option>
                                                            {unloadingLocations?.map((loc) => (
                                                                <option key={loc.id} value={loc.id}>
                                                                    {loc.location_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    {/* Bay */}
                                                    <div style={{ flex: 1, minWidth: "170px" }}>
                                                        <label>Bay</label>
                                                        <select
                                                            className="form-control"
                                                            value={AddFormData.bay_id}
                                                            onChange={(e) =>
                                                                setAddFormData({ ...AddFormData, bay_id: Number(e.target.value) })
                                                            }
                                                        >
                                                            <option value="">Select Bay</option>
                                                            {bays?.map((bay) => (
                                                                <option key={bay.id} value={bay.bay_id}>
                                                                    {bay.number}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    {/* Bay Time From & To */}
                                                    <div style={{ flex: 1, minWidth: "170px" }}>
                                                        <label>Bay Time From</label>
                                                        <input
                                                            type="time"
                                                            className="form-control"
                                                            value={AddFormData.bay_time_from}
                                                            onChange={(e) => {
                                                                setAddFormData({ ...AddFormData, bay_time_from: e.target.value });
                                                                setTimeError("");
                                                            }}
                                                        />
                                                    </div>

                                                    <div style={{ flex: 1, minWidth: "170px" }}>
                                                        <label>Bay Time To</label>
                                                        <input
                                                            type="time"
                                                            className="form-control"
                                                            value={AddFormData.bay_time_to}
                                                            onChange={(e) => {
                                                                setAddFormData({ ...AddFormData, bay_time_to: e.target.value });
                                                                setTimeError("");
                                                            }}
                                                        />
                                                    </div>

                                                    {timeError && <div style={{ color: "red", fontSize: "13px" }}>{timeError}</div>}
                                                </form>

                                                {/* Buttons */}
                                                <div style={{ textAlign: "right" }}>
                                                    <button
                                                        type="button"
                                                        onClick={() => setAddModalOpen(false)}
                                                        style={{
                                                            padding: "10px 16px",
                                                            marginRight: "10px",
                                                            backgroundColor: "#e0e0e0",
                                                            color: "#333",
                                                            border: "none",
                                                            borderRadius: "6px",
                                                            fontSize: "13px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            const lastRoute = trip.TripRoutes[0];
                                                            if (lastRoute) {
                                                                const lastTo = lastRoute.bay_time_to;
                                                                if (AddFormData.bay_time_from <= lastTo) {
                                                                    setTimeError(`New route must start after ${lastTo}`);
                                                                    return;
                                                                }
                                                            }
                                                            if (validateTime(AddFormData.bay_time_from, AddFormData.bay_time_to)) {
                                                                handleAddTripRoute();
                                                            }
                                                        }}
                                                        style={{
                                                            padding: "10px 20px",
                                                            backgroundColor: "rgb(10, 69, 149)",
                                                            color: "#fff",
                                                            border: "none",
                                                            borderRadius: "6px",
                                                            fontSize: "13px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        Add
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}





                                </div>
                            ))}
                        </div>

                        {trip.TripRoutes.length > 2 && (
                            <div className="text-center mt-3">
                                <button className="btn btn-link" onClick={handleToggleView}>
                                    {showMore ? "View Less" : "View More"}
                                </button>
                            </div>
                        )}
                    </>
                ) : (
                    <div>No Trip Routes Found</div>
                )}
            </div>

            <div className="actions-section mt-4">
                <button className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
                    <i className="bi bi-arrow-left me-2"></i>
                    Back to Trips
                </button>
            </div>
        </div>
    );
};

export default ViewTrip;
